import { useState } from "react";

export const CategoryFocusButton = ({category}) => {
    const [clicked, setClicked] = useState(false);
    return <button value={category?.value} onClick={() => setClicked(!clicked)} className={clicked ? "clicked" : ""}>
    <div>
      <div>{category.label}</div>
      <div className="sublabel-focus">{category?.sublabel}</div>
    </div>
  </button>
}